import { Component, Input, inject } from "@angular/core";

import { FooterLegalLink } from "@hermes/api-model-shell";
import { LOCALE } from "@hermes/core-app-core";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

@Component({
    selector: "h-footer-legal-links-deprecated",
    imports: [SrOnlyNoSnippetDirective],
    templateUrl: "./footer-legal-links-deprecated.component.html",
    styleUrls: ["./footer-legal-links-deprecated.component.scss"],
})
export class FooterLegalLinksDeprecatedComponent {
    private locale = inject(LOCALE);

    @Input({ required: true })
    public legalLinks: FooterLegalLink[] = [];

    public chinaLicenseLogo = `${this.locale.urlPrefix}/assets/images/china-license.png`;
    public chinaNetworkSecurityLogo = `${this.locale.urlPrefix}/assets/images/china-network-security.png`;
}
